export const Semantic = {
  fontFamily: "'Lexend', sans-serif",
  primary: {
    50: '{green.50}',
    100: '{green.100}',
    200: '{green.200}',
    300: '{green.300}',
    400: '{green.400}',
    500: '{green.500}',
    600: '{green.600}',
    700: '{green.700}',
    800: '{green.800}',
    900: '{green.900}',
  },
  // Secondary, Info, Warn etc...
  colorScheme: {
    light: {
      // Primary color states
      primary: {
        color: '{green.600}', // #059669
        inverseColor: '#ffffff',
        hoverColor: '{green.700}', // #047857
        activeColor: '{green.800}', // #065F46
      },

      // Surface = la tua scala di grigi
      surface: {
        0: '#ffffff', // #FFFFFF
        50: '{gray.50}', // #F8FAFC  ← background principale
        100: '{gray.100}', // #F1F5F9  ← background alt / card
        200: '{gray.200}', // #E2E8F0  ← border
        300: '{gray.300}', // #CBD5E1
        400: '{gray.400}', // #94A3B8  ← text muted
        500: '{gray.500}', // #64748B
        600: '{gray.600}', // #475569  ← text secondary
        700: '{gray.700}', // #334155
        800: '{gray.800}', // #1E293B
        900: '{gray.900}', // #0F172A  ← text primary
      },

      formField: {
        hoverBorderColor: '{primary.300}',
        focusBorderColor: '{primary.500}',
        background: '{surface.0}',
        color: '{surface.800}!important',
        floatLabel: {
          color: '{surface.600}',
        },
      },

      highlight: {
        background: '{green.600}',
        focusBackground: '{green.700}',
        color: '#ffffff',
        focusColor: '#ffffff',
      },
    },
    dark: {
      // Primary color states
      primary: {
        color: '{green.500}', // #059669
        inverseColor: '{surface.50}',
        hoverColor: '{green.600}', // #047857
        activeColor: '{green.700}', // #065F46
      },
      text: {
        color: '{surface.800}',
      },

      // Surface = la tua scala di grigi
      surface: {
        0: '{gray.900}', // #0F172A  ← text primary
        50: '{gray.800}', // #1E293B
        100: '{gray.700}', // #334155
        200: '{gray.600}', // #475569  ← text secondary
        300: '{gray.500}', // #64748B
        400: '{gray.400}', // #94A3B8  ← text muted
        500: '{gray.300}', // #CBD5E1
        600: '{gray.200}', // #E2E8F0  ← border
        700: '{gray.100}', // #F1F5F9  ← background alt / card
        800: '{gray.50}', // #F8FAFC  ← background principale
        900: '#ffffff', // #FFFFFF
      },

      formField: {
        hoverBorderColor: '{primary.200}',
        focusBorderColor: '{primary.300}',
        background: '{surface.50}!important',
        color: '{surface.800}!important',
        floatLabel: {
          color: '{surface.600}',
        },
      },

      highlight: {
        background: '{green.600}',
        focusBackground: '{green.700}',
        color: '#ffffff',
        focusColor: '#ffffff',
      },
    },
  },
};
